import React, { Fragment, useState } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import { store } from '../../../../../store/store';
import { hideNotification } from '../../../../../store/actions/notification';
import { SendEmailClientModal } from "../../modals/SendEmailClientModal";

function SendEmailClient(props) {
  const [showSendEmailModal, setShowSendEmailModal] = useState(false);
  const {index, actionCallback, user, showIcon} = props;

  return (<Fragment>
      {!showIcon ?
        <Fragment>
          <Button
            color="primary"
            size="sm"
            className="btn-warning"
            type="button"
            id={`send-email-user-icon-${index}`}
            onClick={() => {
              store.dispatch(hideNotification());
              setShowSendEmailModal(true)
            }}
          >
            <FormattedMessage
              id="components.pages.clients.table.actionButtons.send_email_user"/>
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={`send-email-user-icon-${index}`}
            boundariesElement="viewport"
            positionFixed
          >
            <FormattedMessage
              id="components.pages.clients.table.actionButtons.send_email_user"/>
          </UncontrolledTooltip>
        </Fragment> :
        <Fragment>
          <Link
            to="#"
            className="cursor-pointer px-2 mx-2 link-icon-color"
            id={`send-email-user-icon-` + props.index}
            onClick={() => setShowSendEmailModal(true)}
          >
            <FontAwesomeIcon
              size="lg"
              className="cursor-pointer"
              pointerEvents="none"
              icon={faEnvelope}
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={`send-email-user-icon-${props.index}`}
            boundariesElement="viewport"
            positionFixed
          >
            <FormattedMessage
              id="components.pages.clients.table.actionButtons.send_email_user"/>
          </UncontrolledTooltip>
        </Fragment>
      }

      <SendEmailClientModal
        showModal={showSendEmailModal}
        closeModal={() => setShowSendEmailModal(false)}
        user={user}
        actionCallback={actionCallback}
      />
    </Fragment>
  );
}

export { SendEmailClient };
